import React, { Component } from 'react';
import { Form, Button } from "react-bootstrap";
import { Divider, Tooltip, message } from 'antd';
import { Link } from "react-router-dom";
import Head from '../components/Head';
import { auth } from "../config/fire";
import {
    signup, signin,
    // signInWithGoogle
} from '../helpers/auth';
import CreateMeetModal from '../components/Modals/createMeetModal';
import JoinMeetingModal from '../components/Modals/joinMeetingModal';
import {
    Container, HomeRowContainer, HomeConnectButton, HomeSignContainer, LogSuggestion,HomeImageContainer,
    //  UserDetailsCard,
    EventsViewLinkButton, HomeActionCard
} from './styles';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { faEyeSlash, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import BlockImg from '../images/main.png';
import GoogleImg from '../images/google.png';

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.btnref = React.createRef();
        this.rbtnref = React.createRef();
        this.state = {
            modalVisibility: false,
            joinModalVisible: false,
            lerror: null,
            rerror: null,
            email: '',
            lemail: '',
            remail: '',
            rpwd: '',
            lpwd: '',
            load: false,
            rload: false,
            password: '',
            action: 'login',
            propsname: this.props.uname,
            

        };
        document.title = "Home";
        localStorage.clear();

        this.handleChange = this.handleChange.bind(this);
        this.handleReg = this.handleReg.bind(this);
        // this.googleSignIn = this.googleSignIn.bind(this);
        this.handleLog = this.handleLog.bind(this);
        this.success = this.success.bind(this)
    }
    

    componentDidMount(props){
        
        if(auth().currentUser && !auth().currentUser.displayName){
            message.error({
                content: 'Please Provide Your Name',
                duration: [2]
            })
        }
        // if(!this.state.props.uname){
        //     message.error({
        //         content: 'Please Provide Your Name',
        //         duration: [5]
        //     })
        // } 
        
    
    
    }
    
    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    success(){
        this.setState({
            modalVisibility: false,
        })
    }
    async handleLog(event) {
        event.preventDefault();
        this.btnref.current.disabled = true;
        this.setState({ lerror: '', load: true, });

        if(this.state.lemail === ''){
            this.setState({
                lerror: 'Please Provide Email Address',
                load: false
            });
            this.btnref.current.disabled = false;
            return;
        }
        if(this.state.lpwd === ''){
            this.setState({
                lerror: 'Please Provide Password',
                load: false,
            });
            this.btnref.current.disabled = false;
            return;
        }

        try {
            if (typeof (this.props.location.state) !== 'undefined') {

                this.fromm = this.props.location.state.from.pathname;
                localStorage.setItem('from', this.fromm);

            }

            await signin(this.state.lemail, this.state.lpwd).then(
                () => {
                    this.setState({
                        load: false,
                    })
                    message.success({
                      content: 'Logged In SuccesFully',
                      duration: [2]
                    })
                }
            )

            this.setState({ lemail: '', lpwd: '' })
            // window.location.replace('/Dashboard')
            // this.props.history.push("/Dashboard");


        } catch (error) {
            this.btnref.current.disabled = false;
            var code = error.code;
            var errorr;
             
            if(code === 'auth/invalid-email'){
                errorr = 'The Email is Invalid'
            }
            else if(code === 'auth/user-not-found'){
                errorr = 'There is No User With this Email'
            }
            else if(code === 'auth/wrong-password'){
                errorr = 'The Password is Wrong '
            }
            else{
                errorr = 'Something Problem With Your Network';
            }

            this.setState({ lerror: errorr, load: false });
            this.btnref.current.disabled = false;
            message.error({
                content: 'Logged In Failed',
                duration: [2]
            })
        }
    }
    // async googleSignIn() {
    //   try {
    //     await signInWithGoogle();
    //     this.state = {
    //       user: auth().currentUser,
    //     }

    //   } catch (error) {
    //     this.setState({ error: error.message });
    //   }
    // }
    async handleReg(event) {
        event.preventDefault();
        this.rbtnref.current.disabled = true;
        this.setState({ rerror: '', rload: true, });

        if(this.state.remail === ''){
            this.setState({
                rerror: 'Please Provide Email Address',
                rload: false
            });
            this.rbtnref.current.disabled = false;
            return;
        }
        if(this.state.rpwd === ''){
            this.setState({
                rerror: 'Please Provide Password',
                rload: false,
            });
            this.rbtnref.current.disabled = false;
            return;
        }
        
        try {
            await signup(this.state.remail, this.state.rpwd)
            this.props.history.push('/UserProfile')

            this.setState({ remail: '', rpwd: '' })

        } catch (error) {
            var code = error.code;
            var errorr;
            if(code === 'auth/email-already-in-use'){
            errorr = 'The Given Email is Already in use'
            }
            else if(code === 'auth/invalid-email'){
             errorr = 'The Given Email is Invalid'
            }
            else if(code === 'auth/weak-password'){
             errorr = 'The Password is too Weak Choose Another'
            }
            else{
             errorr = 'Something Problem With Your Network'
            }
            this.setState({ rerror: errorr, rload: false });
            this.rbtnref.current.disabled = false;
        }
    }

    handleActionSelection = (actionType) => {
        this.setState({
            action: actionType
        })
    }

    render() {
        return (
            <Container>
                <Head HandleActionSelection={this.handleActionSelection} />
                <HomeRowContainer className='row'>
                    <div className='col-md-6 offset-md-1 col-md-offset-right-1' >
                        <div>
                            <p className='home-main-head'>
                                Want to connect more
                            </p>
                            <p className='home-description'>
                                Using ourapp people can connect more than 50 participants and we have provided more features.
                                To see the features let's get started.
                            </p>
                        </div>
                        <HomeImageContainer>
                            <img src={BlockImg} alt='main-image' />
                        </HomeImageContainer>
                    </div>
                    <div className='col-md-3  offset-md-1 col-md-offset-right-1'>
                        {
                            auth().currentUser &&
                            <div>
                                <HomeActionCard style={{ marginBottom: '1rem', }}>
                                    <p> Let's get started</p>
                                    <HomeConnectButton width='125px' height='32px' fontsize='14px'
                                        onClick={() => this.setState({ modalVisibility: true })}
                                    >Create meeting</HomeConnectButton>
                                </HomeActionCard>

                                <HomeActionCard>
                                    <p> Want to join meeting?</p>
                                    <HomeConnectButton width='125px' height='32px' fontsize='14px'
                                        onClick={() => this.setState({ joinModalVisible: true })}
                                    >Join meeting</HomeConnectButton>
                                </HomeActionCard>
                            </div>
                        }

                        {
                            !auth().currentUser && this.state.action === 'register' &&
                            <Form onSubmit={this.handleReg} className="auth-form">
                                <Form.Group controlId="formGroupEmail">
                                    <Form.Control name="remail" onChange={this.handleChange} value={this.state.remail} id="remail" type="email" placeholder="Enter email" />
                                </Form.Group>
                                <Form.Group controlId="formGroupPassword">
                                    <Form.Control name="rpwd" onChange={this.handleChange} value={this.state.rpwd} id="rpwd" type="password" placeholder="Password" />
                                </Form.Group>
                                {this.state.rerror ?<strong> <p className="text-danger">{this.state.rerror}</p></strong> : null}
                                <Button type="submit" ref={this.rbtnref} >{this.state.rload ? 'Loading': 'Register'}</Button>
                                <LogSuggestion>Already have account? <span onClick={() => this.handleActionSelection('login')}>Login</span></LogSuggestion>
                                <Divider plain className='divider'>Or connect with</Divider>
                                <HomeSignContainer>
                                    <div className='google-icon' onClick={this.googleSignIn}>
                                        <img src={GoogleImg} alt='google-image' />
                                    </div>
                                </HomeSignContainer>

                            </Form>
                        }
                        {
                            !auth().currentUser && this.state.action === 'login' &&
                            <Form onSubmit={this.handleLog} className="auth-form">
                                <Form.Group controlId="formGroupEmail">
                                    <Form.Control name="lemail" onChange={this.handleChange} value={this.state.lemail} id="lemail" type="email" placeholder="Enter email" />
                                </Form.Group>
                                <Form.Group controlId="formGroupPassword">
                                    <Form.Control name="lpwd" onChange={this.handleChange} value={this.state.lpwd} id="lpwd" type="password" placeholder="Password" />
                                    <FontAwesomeIcon className='fa-icon' icon={faEyeSlash} />
                                </Form.Group>
                                {this.state.lerror ? <strong> <p className="text-danger">{this.state.lerror}</p></strong> : null}
                                <Button type="submit" ref={this.btnref} className='submit-button'>{this.state.load ? 'Loading' : 'Login'}</Button>
                                <LogSuggestion>Don't have an account? <span onClick={() => this.handleActionSelection('register')}>Register</span></LogSuggestion>
                                <Divider plain className='divider'>Or connect with</Divider>
                                <HomeSignContainer>
                                    <div className='google-icon' onClick={this.googleSignIn}>
                                        <img src={GoogleImg} alt='google-image' />
                                    </div>
                                </HomeSignContainer>
                            </Form>
                        }
                    </div>
                </HomeRowContainer>
                {auth().currentUser &&
                <Tooltip placement="top" title={'View Events'}>
                    <EventsViewLinkButton>
                        <Link to='/MyEvents'>
                            <FontAwesomeIcon className='fa-icon' icon={faCalendarAlt} />
                        </Link>
                    </EventsViewLinkButton>
                </Tooltip>
    }

                {
                    this.state.modalVisibility &&
                    <CreateMeetModal
                        success={this.success}
                        visibility={this.state.modalVisibility}
                        onClose={() => { this.setState({ modalVisibility: false }) }}
                    />
                }
                {
                    this.state.joinModalVisible &&
                    <JoinMeetingModal
                        visibility={this.state.joinModalVisible}
                        onClose={() => { this.setState({ joinModalVisible: false }) }}
                    />
                }
                
            </Container >

        );
    }
};